import {
  Height,
  InfoButtonsLayout,
  InfoButtonsWidth,
  InfoMaxWidth,
  SectionLayout,
  SectionTypeEnum,
} from '@nucleus/types/web';
import { Alignment } from '@nucleus/types/web/alignment';
import { Position } from '@nucleus/types/web';
import { SectionDefaultBuilder } from '../SectionDefaultBuilder';
import { blockMediaOptionsDefault } from '../helpers';

const builder = new SectionDefaultBuilder<SectionTypeEnum.Gallery>().setStatic((config) => ({
  name: config.title,
  layout: SectionLayout.Full,
  backgroundMedia: { presetMediaKey: 'sectionBackground', presetMediaOrder: 'first' },
  blockBackgroundMedia: { presetMediaKey: 'blockBackground', presetMediaOrder: 'first' },
  colorPaletteVariation: 'variation-1',
  height: Height.Medium,
  blocks: [{}],
  blockLayout: config.layout,
  blockLayoutVariant: 'variant1',
  blockEnabledInfo: { overline: true, headline: true, byline: false, body: true },
  blockInfoPosition: Position.Center,
  blockHeadlineAlignment: Alignment.Left,
  blockHeadlineMaxWidth: InfoMaxWidth.Medium,
  blockBodyAlignment: Alignment.Left,
  blockButtonsAlignment: Alignment.Left,
  blockButtonsLayout: InfoButtonsLayout.Vertical,
  blockButtonsWidth: InfoButtonsWidth.Auto,
  blockMediaOptions: blockMediaOptionsDefault(config.lookConfig),
}));

export default builder.build();
